export const formatResponse = (productGroupsResponse, isGenericProp = false, orderProductIdParentProp = null) => {
    if (productGroupsResponse?.length === 0) return [];

    return productGroupsResponse?.map((product: any) => {
        if (!!product) {
            return {
                ...product,
                ...formatProduct(product, isGenericProp, orderProductIdParentProp),
                generics:
                    product?.generics?.length > 0
                        ? product.generics.map((p) => ({
                              ...p,
                              ...formatProduct(p, true, product.order_product_id),
                              generics: [],
                          }))
                        : [],
            };
        }
    });
};

const formatProduct = (product: any, isGeneric = false, orderProductIdParent = null) => {
    return {
        drugManufacturerIdSelected: !Boolean(product?.selectedProduct?.drug_manufacturer_id)
            ? product?.suggested
            : product?.selectedProduct
            ? product?.selectedProduct?.drug_manufacturer_id
            : product?.suggested,
        areAllItemChecked: product?.suggested?.length === 0 && product?.lowest_without_cdo?.length > 1,
        amountSelected: amountSelected(product),
        isManualSelected: false,
        isFatherGeneric: product?.generics?.length > 0,
        isGeneric: isGeneric,
        orderProductIdParent: orderProductIdParent,
    };
};

const amountSelected = (product: any) => {
    if (product?.suggested?.length === 0) {
        return 0;
    }
    const values = product?.suggested?.map((i) => {
        return product?.products?.[i]?.total || 0;
    });

    if (values?.length) {
        return values?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }
};
